import { useXingHub } from '@xingternal/xing-hub';
import { useQuery } from 'react-apollo';
import { useState } from 'react';
import { getRegisteredExperiments } from './register-experiment';
import { ExperimentsDocument as GET_EXPERIMENTS } from './experiments.gql-types';
const FALLBACK_VARIANT = 'A';
const experimentNamesByType = (registeredExperiments, experimentType) => {
    const registeredExperimentNames = registeredExperiments
        .filter((experiment) => experiment.experimentType === experimentType)
        .map((experiment) => experiment.name);
    return (registeredExperimentNames === null || registeredExperimentNames === void 0 ? void 0 : registeredExperimentNames.length) > 0
        ? registeredExperimentNames
        : 'NONE';
};
const getExperimentVariantOrFallback = (experiment) => {
    if (!experiment)
        return FALLBACK_VARIANT;
    const supportedVariants = experiment.supportedVariants || [];
    const isCaseSupported = supportedVariants.includes(experiment.variant);
    const hasError = experiment.status === 500;
    // A is alsways the default and fallback if something goes wrong or if case is not supported
    if (hasError || !isCaseSupported)
        return FALLBACK_VARIANT;
    return experiment.variant;
};
const prepareExperiments = (data, experiments) => {
    var _a, _b, _c, _d, _e;
    const rawVisitorExperiments = (_b = (_a = data === null || data === void 0 ? void 0 : data.featureSwitchesLoggedOutExperiments) === null || _a === void 0 ? void 0 : _a.collection) !== null && _b !== void 0 ? _b : [];
    const rawUserExperiments = (_e = (_d = (_c = data === null || data === void 0 ? void 0 : data.viewer) === null || _c === void 0 ? void 0 : _c.featureSwitchesExperiments) === null || _d === void 0 ? void 0 : _d.collection) !== null && _e !== void 0 ? _e : [];
    const rawExperiments = [
        ...rawUserExperiments,
        ...rawVisitorExperiments,
    ];
    for (const rawExp of rawExperiments) {
        if (experiments[rawExp.name]) {
            experiments[rawExp.name] = {
                ...experiments[rawExp.name],
                status: 200,
                variant: rawExp.variant,
            };
        }
    }
};
export const splitkitHubModule = {
    name: 'splitkitHubModule',
    getHooks: () => {
        const useFetchExperiments = () => {
            const { visitorId } = useXingHub();
            const visitorIdOrFallback = visitorId || new Date().getTime().toString();
            const registeredExperiments = getRegisteredExperiments();
            // initialising with NOT FOUND and A as the fallback
            let experiments = registeredExperiments === null || registeredExperiments === void 0 ? void 0 : registeredExperiments.reduce((index, next) => {
                index[next.name] = {
                    ...next,
                    variant: FALLBACK_VARIANT,
                    status: 404,
                };
                return index;
            }, {});
            const [variables] = useState({
                userExperimentNames: experimentNamesByType(registeredExperiments, 'user'),
                visitorExperimentNames: experimentNamesByType(registeredExperiments, 'visitor'),
                visitorId: visitorIdOrFallback,
            });
            const { data, error, loading } = useQuery(GET_EXPERIMENTS, { variables });
            if (error) {
                Object.values(experiments).forEach((exp) => (exp.status = 500));
            }
            else if (Object.keys(experiments).length) {
                prepareExperiments(data, experiments);
            }
            return { experiments, isLoading: loading };
        };
        const useExperiment = (name) => {
            const { experiments } = useFetchExperiments();
            const experiment = experiments === null || experiments === void 0 ? void 0 : experiments[name];
            return getExperimentVariantOrFallback(experiment);
        };
        const useExperimentsLoadingState = () => {
            const { isLoading } = useFetchExperiments();
            return { isLoading };
        };
        const useExperimentTrackingData = () => {
            const { experiments } = useFetchExperiments();
            if (experiments && Object.values(experiments).length > 0) {
                const runningExperiments = Object.values(experiments);
                let propExperiment = [];
                let propExperimentInfo = [];
                for (const experiment of runningExperiments) {
                    const displayed = experiment.status === 200
                        ? getExperimentVariantOrFallback(experiment)
                        : FALLBACK_VARIANT;
                    const received = experiment.status === 200 ? experiment.variant : '0';
                    const shortExperimentName = experiment.name.replace('ABACUS', 'A');
                    // data means
                    // - name of the experiment
                    // - which variant was displayed (A if something went wrong)
                    // - which variant was reported by the backend (0 if something went wrong)
                    propExperiment.push(`${shortExperimentName}|${displayed}|${received}`);
                    // TODO: Replace with proper Error tracking via sentry, PropExperimentInfo is therefore not needed
                    // data means
                    // - name of the experiment
                    // - status: 200 = OK, 404 = experiment not found, 500 = error during request
                    // - user type: U = logged in, V = logged out
                    const experimentType = experiment.experimentType === 'user' ? 'U' : 'V';
                    const experimentInfo = [
                        shortExperimentName,
                        experiment.status,
                        experimentType,
                    ].join('|');
                    propExperimentInfo.push(experimentInfo);
                }
                return {
                    PropExperiment: propExperiment.join(','),
                    PropExperimentInfo: propExperimentInfo.join(','),
                };
            }
            else {
                return {};
            }
        };
        return {
            useFetchExperiments,
            useExperiment,
            useExperimentTrackingData,
            useExperimentsLoadingState,
        };
    },
};
//# sourceMappingURL=splitkit-hub-module.js.map